// extracted by mini-css-extract-plugin
export default {"waitSpinner":"Spinner_waitSpinner__gvCqY","rotator":"Spinner_rotator__WitJo","path":"Spinner_path__e4FKY","dash":"Spinner_dash__s64Ij","colors":"Spinner_colors__ACZFq"};